module.exports = __webpack_public_path__ + "static/media/kitchen7.6d2c1f61.jpg";